module.exports = __webpack_public_path__ + "static/jan-bussieck-gray-f98aa166bc686f2ac09e0960372076b8.png";